import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { GetInput } from './GetInput';
import classNames from 'classnames';

const GetCharacteristicsGrid = ({
  row,
  errors,
  touched,
  values,
  setValues,
  handleChangeCarac,
  handleChangeCaracObj,
  parent,
  parentIndex
}) => {
  return (
    <Row
      className={classNames('g-3', {
        'gy-4': row.some(col => col.title) || parent,
        'gx-6': row.some(col => col.title) || parent
      })}
    >
      {row.map((col, index) => (
        <Col key={index} {...col.props}>
          {col.title && (
            <>
              <hr
                className={classNames({
                  'd-lg-block': index !== 0,
                  'd-lg-none': index === 0,
                  'd-none': parentIndex === 0 && index === 0,
                  'd-block': parentIndex !== 0 || index !== 0
                })}
              />

              <h5>{col.title}</h5>
            </>
          )}

          {col.child && (
            <GetInput
              key={`${col.child.type}-${index}`}
              input={col.child}
              errors={errors}
              touched={touched}
              values={values}
              setValues={setValues}
              handleChangeCarac={handleChangeCarac}
              handleChangeCaracObj={handleChangeCaracObj}
            />
          )}

          {col.row && (
            <GetCharacteristicsGrid
              row={col.row}
              errors={errors}
              touched={touched}
              values={values}
              setValues={setValues}
              handleChangeCarac={handleChangeCarac}
              handleChangeCaracObj={handleChangeCaracObj}
              parentIndex={index}
            />
          )}
        </Col>
      ))}
    </Row>
  );
};

GetCharacteristicsGrid.propTypes = {
  row: PropTypes.array,
  errors: PropTypes.object,
  touched: PropTypes.object,
  values: PropTypes.object,
  setValues: PropTypes.func,
  handleChangeCarac: PropTypes.func,
  handleChangeCaracObj: PropTypes.func,
  parent: PropTypes.bool,
  parentIndex: PropTypes.number
};

export default GetCharacteristicsGrid;
